module.exports = g_version;